<template lang="html">
  <div class="teaser-tile-solo-list">
    <TeaserTileContent
      v-for="item in resource.children"
      :key="item.id"
      :resource="item"
    />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TeaserTileContent from 'beisheim/components/blocks/teaser-tile-content'

export default {
  components: {
    TeaserTileContent
  },
  mixins: [ editable ]
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/breakpoints';

  .teaser-tile-solo-list {
    display: flex;
    flex-direction: column;
    margin: scale(1) auto;
    min-width: $min-width;
    max-width: $max-width;

    @include from(4) {
      @include grid-spacing(margin-bottom, 4);
      flex-direction: row;
      flex-wrap: wrap;

      .teaser-tile-content:nth-child(even) {
        position: relative;
        top: #{$grid * 2};

        @media screen and (min-width: $max-width) {
          position: relative;
          top: #{($max-width / 24) * 2};
        }
      }
    }
  }
</style>
